export default {
  saveFacility: "/additionalFacility/saveFacility",
  getAllFacility: "/additionalFacility/getAllFacility",
  editFacility: "/additionalFacility/editFacility",
  deleteFacility: "/additionalFacility/deleteFacility",
  getAllUsedFacilityCount: "/additionalFacility/getAllUsedFacilityCount",
};
